module.exports = __webpack_public_path__ + "static/media/img_roadmap_withtxt.513fb309.png";